import React from 'react';
import { Helmet } from 'react-helmet-async';
import MasterLayout from '../../masterLayout/MasterLayout';
import Breadcrumb from '../../components/Breadcrumb';
import SecuritySettings from '../components/security/SecuritySettings';

const SecuritySettingsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Security Settings" />

        {/* LicenseList */}
        <SecuritySettings />
      </MasterLayout>
    </>
  );
};

export default SecuritySettingsPage;
